// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop--backdrop--2YB0w"};